export default "#ifdef GL_ES\nprecision highp float;\n#define GLSLIFY 1\n#endif\n\nvoid main(void) {\n    gl_FragColor = vec4(0.5, 0.5, 0.5, 0.1);\n}\n"